import { render, staticRenderFns } from "./IPhone.vue?vue&type=template&id=aa49d416"
import script from "./IPhone.vue?vue&type=script&lang=js"
export * from "./IPhone.vue?vue&type=script&lang=js"
import style0 from "./IPhone.vue?vue&type=style&index=0&id=aa49d416&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports